import React, { useCallback } from 'react';

import { useField } from 'formik';
import Timepicker from '..';

const TimepickerMemo = React.memo(Timepicker);

const TimepickerCFormik = (props) => {
	const { name } = props;
	const [field, meta, helpers] = useField(name);
	const { setValue } = helpers;

	const handleChange = useCallback((value) => {
		setValue(value);
	}, [setValue]);

	if (!name) return 'For Timepicker connected to Formik name is required!';

	return (
		<TimepickerMemo
			value={field.value}
			onChange={handleChange}
			onBlur={field.onBlur}
			error={(meta.touched || meta.initialTouched) && meta.error}
			{...props}
		/>
	);
};

TimepickerCFormik.propTypes = {
	...Timepicker.propTypes,
};

export default TimepickerCFormik;
